import React from 'react';
import Reflux from 'reflux';
import Header from '../sections/Header';
import Footer from '../sections/Footer';
import AppActions from '../AppActions';
import ProfileStore from '../stores/ProfileStore';
import ProfileActions from '../actions/ProfileActions';
import AppStore from '../AppStore';
import history from '../history';
import ErrorSign from '../sections/ErrorSign';
import '../sections/EditProfile.css';

class EditProfilePage extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            username: '',
            screenName: '',
            error: ''
        };
        this.stores = [AppStore, ProfileStore];
    }
    componentDidMount () {
        if (this.state.userLogged && this.state.userData.username) {
            ProfileActions.getProfile(this.state.userData.username);
        } else {
            history.push('/notfound');
        }
    }
    componentWillReceiveProps () {
        this.setState({
            username: this.state.profile.username,
            screenName: this.state.profile.screen_name
        });
    }
    logout = () => {
        AppActions.logout();
    }
    onChangeScreenName = (event) => {
        this.setState({screenName: event.target.value});
    }
    onChangeUsername = (event) => {
        this.setState({username: event.target.value});
    }
    saveProfile = () => {
        if (/\s/.test(this.state.username)) {
            this.setState({error: 'El @ no puede tener espacios'});
        } else {
            let updatedProfile = {
                screen_name: this.state.screenName,
                username: this.state.username
            };
            ProfileActions.editProfile(updatedProfile, this.state.user._id);
        }
    }
    render () {
        return (
          <div>
            <Header />
            <main className='relative'>
              <div className='row content-editProfile'>
                <div className='form-content-user'>
                  <h4 className='title-home'><span>Editar Perfil</span></h4>
                  <div className='content-image-change'>
                    <div>
                      <object type='image/jpg' data={this.state.profile && this.state.profile.profile_image && this.state.profile.profile_image.sizeLarge ? this.state.profile.profile_image.sizeSmall : '/images/icons/default-big.jpg'}>
                        <img src='/images/icons/default-big.jpg' />
                      </object>
                    </div>
                    <span className='hide'><i className='fa fa-pencil' aria-hidden='true' /></span>
                  </div>
                  <div className='field-form'>
                    <label>Nombre de Usuario</label>
                    <input type='text' value={this.state.screenName} onChange={this.onChangeScreenName} />
                  </div>
                  <div className='field-form'>
                    <label>@</label>
                    <input type='text' value={this.state.username} onChange={this.onChangeUsername} />
                  </div>
                </div>
                <div className='row btn_action_profile'>
                  <a className='btn btn-primary waves-light waves-effect btn-negative' onClick={() => { history.push('/'); }} >Cancelar</a>
                  <a className='btn btn-primary waves-effect waves-light btn-green' onClick={this.saveProfile}>Guardar</a>
                </div>
                <div className='row out-in-mobile'>
                  <a href='#'>Términos y condiciones</a>
                  <a onClick={this.logout}>Cerrar Sesión</a>
                </div>
              </div>
              {this.state.errorEditingScreenName && <p> Ese username ya está siendo usado por otro usuario.</p>}
              <ErrorSign title={'Error editando perfil'} description={this.state.error} />
            </main>
            <Footer />
          </div>
        );
    };
}
export default EditProfilePage;



// WEBPACK FOOTER //
// ./src/pages/EditProfilePage.js